import { CircularProgress, Toolbar } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import SchoolAdminDashboard from "../component/schoolAdminPortal/schoolAdminDashboard";
import editIcon from "../assets/images/editIcon.png";
import backarrow from "../assets/images/back-arrow.png";
import schoolLogo from "../assets/images/default_school.png";
import blankProfile from "../component/schoolAdminPortal/images/blank-profile.png";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";
import { useSelector } from "react-redux";

const UserProfile = ({
  schoolData,
  groupAthletes,
  assignSportsList,
  activeSports,
  adminRightsList,
  activeRightsList,
  flag,
  URL,
  loading,
}) => {
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  return (
    <div>
      <SchoolAdminDashboard />
      <div
        //className="content-layout p-0"
        className={
          isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
        }
      >
        {loading ? (
          <div className="content-layout-loading-animation">
            <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
              <CircularProgress
                className="rounded-circle"
                color="success"
                sx={{ fontSize: 10, color: "#002244" }}
                disableShrink
              />
            </div>
          </div>
        ) : (
          <>
            <Toolbar className="tb-p">
              <div className="mng-add-header stickyy mg-bottom-0 ">
                <div>
                  <p>
                    <Link to="/schooladmindashboard">
                      <span className="backbtn">
                        <img className="mb-1" src={backarrow} alt=" " />
                      </span>{" "}
                    </Link>

                    <label className="txt-blue bold fs-18">BACK TO FEEDS</label>
                  </p>
                </div>
                <div>
                  <Link to={URL}>
                    <img
                      src={editIcon}
                      className="ed-icn cp icon-hover"
                      alt="alt"
                    />
                  </Link>
                </div>
              </div>
            </Toolbar>
            <div>
              <div className="mng-add-header mg-bottom-0 mg-top-0 header-height border-temdtls">
                <div>
                  <div className="dflex align-items-center mx-2">
                    <img
                      className="details-profile img-fluid mg-right-10"
                      src={
                        schoolData.uploadedLogo
                          ? schoolData.uploadedLogo.filePath
                          : blankProfile
                      }
                      alt="PIC"
                    />

                    <div>
                      <label className="fs-30 bold athlete-nm mg-bottom-0">
                        {schoolData.firstName} {schoolData.lastName}
                      </label>
                      {flag === "athlete" && (
                        <lebel className="badgestyle ml-2">
                          {schoolData.jerseyNumber}
                        </lebel>
                      )}

                      {flag === "athlete" && (
                        <h6 className="mt-1 semi-bold fs-18">
                          {schoolData.positionPlayed}
                        </h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row px-2">
                <div className="col-12 col-lg-6 col-md-12  w-100 plr pt-1 ">
                  <div className="clear10"></div>
                  <div className="row p-1 ">
                    <label className="fs-20 bold">Personal Information</label>
                  </div>
                  <div>
                    <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1  team-details fs-18">
                      <div className="clear10 col-md-12"></div>
                      <div className="row p-1">
                        <div className="col-12 col-lg-4 col-md-4 fmlabel">
                          <label>Date Joined</label>
                        </div>
                        <div className="col-12 col-lg-8 col-md-8">
                          <p>
                            {moment(schoolData.createdAt).format("MM/DD/YYYY")}
                          </p>
                        </div>
                      </div>
                      <div className="row p-1">
                        <div className="col-12 col-lg-4 col-md-4 fmlabel">
                          <label>Email</label>
                        </div>
                        <div className="col-12 col-lg-8 col-md-8">
                          <p>{schoolData.email}</p>
                        </div>
                      </div>
                      <div className="row p-1">
                        <div className="col-12 col-lg-4 col-md-4 fmlabel">
                          <label>Contact</label>
                        </div>
                        <div className="col-12 col-lg-8 col-md-8">
                          <p>{schoolData.phoneNumber}</p>
                        </div>
                      </div>
                      {flag !== "athlete" && (
                        <div className="row p-1">
                          <div className="col-12 col-lg-4 col-md-4 fmlabel">
                            <label>Specialty</label>
                          </div>
                          <div className="col-12 col-lg-8 col-md-8">
                            <p>{schoolData.specialty}</p>
                          </div>
                        </div>
                      )}

                      {flag === "athlete" && (
                        <div>
                          <div className="row p-1">
                            <div className="col-12 col-lg-4 col-md-4 fmlabel">
                              <label>Graduation Year</label>
                            </div>
                            <div className="col-12 col-lg-8 col-md-8">
                              <p>{schoolData.graduationYear}</p>
                            </div>
                          </div>
                          <div className="row p-1">
                            <div className="col-12 col-lg-4 col-md-4 fmlabel">
                              <label>Position Played</label>
                            </div>
                            <div className="col-12 col-lg-8 col-md-8">
                              <p>{schoolData.positionPlayed} </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1 mt-3 team-details fs-18">
                      <div className="clear10 col-md-12"></div>
                      <div className="row p-1">
                        <div className="col-12 col-lg-4 col-md-4 fmlabel">
                          <label>Group</label>
                        </div>
                        <div className="col-12 col-lg-8 col-md-8">
                          <div>
                            {groupAthletes?.length
                              ? groupAthletes?.map((data, index) => (
                                  <p className="fs-18 semi-bold" key={index}>
                                    {data.name}
                                  </p>
                                ))
                              : "--"}
                          </div>
                        </div>
                      </div>
                      <div className="clear10"></div>
                    </div>
                    {flag === "athlete" && (
                      <div className="col-12 col-lg-12 col-md-10  w-100 plr pt-1 mt-3 team-details fs-18">
                        <div className="clear10 col-md-12"></div>

                        <div className="row p-1">
                          <div className="col-12 col-lg-4 col-md-4 fmlabel">
                            <label>Instagram</label>
                          </div>
                          <div className="col-12 col-lg-8 col-md-8">
                            <p>
                              {schoolData.instagramLink
                                ? schoolData.instagramLink
                                : "--"}
                            </p>
                          </div>
                        </div>
                        <div className="row p-1">
                          <div className="col-12 col-lg-4 col-md-4 fmlabel">
                            <label>Twitter</label>
                          </div>
                          <div className="col-12 col-lg-8 col-md-8">
                            <p>
                              {schoolData.twitterLink
                                ? schoolData.twitterLink
                                : "--"}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="clear10"></div>
                </div>
                <div className="col-12 col-lg-6 col-md-10 ">
                  {flag !== "athlete" && (
                    <div className="team-details2">
                      <h6 className="team-title bold fs-18">Assigned Rights</h6>

                      <div className="athlete-details  mt-1">
                        {adminRightsList.map((data, index) => (
                          <div className="admin-role" key={index}>
                            <Checkbox
                              icon={
                                <BsCircle fontSize="20px" color="#13005A" />
                              }
                              checkedIcon={
                                <BsFillCheckCircleFill
                                  fontSize="20px"
                                  color="#13005A"
                                />
                              }
                              checked={activeRightsList.includes(data.id)}
                              className="rights-check-icon opacity05"
                              disabled
                            />
                            <h6 className="mx-2">{data.displayName}</h6>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="clear20"></div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
